/* tslint:disable:max-classes-per-file */
import { ErrorDTO } from './ErrorDTO';
/**
 * Clase que representa un error de validacion
 *
 * @class ValidationErrorDTO
 * @extends {ErrorDTO}
 */
export class ValidationErrorDTO extends ErrorDTO {
    /**
     * Crea una instancia de ValidationErrorDTO.
     * @param {string} code codigo de error (string parseable por el sistema)
     * @param {string} message descripcion del error (mensaje a mostrar al usuario)
     * @param {ValidationFieldError[]} fields lista de campos con error y su descripcion
     * @memberof ValidationErrorDTO
     */
    constructor(code, message, fields) {
        super(code, message);
        this.fields = fields;
    }
}
/**
 * Clase que representa un error de validacion en un campo determinado.
 *
 * @class ValidationFieldError
 */
export class ValidationFieldError {
    /**
     * Crea una instancia de ValidationFieldError.
     * @param {string} name nombre del campo erroneo
     * @param {string} description descripcion del error
     * @memberof ValidationFieldError
     */
    constructor(name, description) {
        this.name = name;
        this.description = description;
    }
}
//# sourceMappingURL=ValidationErrorDTO.js.map